import React from 'react'
import PropTypes from 'prop-types'
import injectStyles from 'react-jss'
import CircularProgress from '@material-ui/core/CircularProgress'
import styles from '../styles'

const ChatConversationsListView = ({ isLoading, children, classes }) => {
  if (isLoading) {
    return (
      <div className={classes.loaderWrapper}>
        <CircularProgress size={25} />
      </div>
    )
  }
  return (
    <section
      className={classes.wrapper}
      cypress_id={'chatConversationsListView'}
    >
      {children}
    </section>
  )
}

ChatConversationsListView.propTypes = {
  classes: PropTypes.object,
}

export default injectStyles(styles)(ChatConversationsListView)
